import { Button, Input, NumberInput, Radio, Select, Skeleton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useAppSelector } from '@hooks/redux/redux';
import classes from './style.module.css';
import { useSettingSIEMSystem } from '@/containers/pages/filials/edit/components/tabs/security/components/setting-siem-system/useSettingSIEMSystem';
import { ExportUserActionsSettingsFormat } from '@/services/api/customerSettingsApiArea/types';
import { IconChevronDown } from '@tabler/icons';

const options = [
  {
    value: ExportUserActionsSettingsFormat.CEF.toString(),
    label: 'CEF'
  },
  {
    value: ExportUserActionsSettingsFormat.LEEF.toString(),
    label: 'LEEF'
  }
];

export const SettingSIEMSystem = () => {
  const { t } = useTranslation();
  const { filial } = useAppSelector((state) => state.filials);

  const [form, handleSubmit, isLoading, isPartLoading, isFormChanged] = useSettingSIEMSystem(
    filial?.Id
  );

  const isDisabledButton = Object.keys(form?.errors || {}).length > 0 || !isFormChanged;

  const currentValue = options.find(
    (e) => e.value === form.getInputProps('Format').value.toString()
  );

  const handleChangeSelectSIEM = (value: string | null) => {
    form.setFieldValue('Format', Number(value));
  };

  const handleChangePort = (value: number | string) => {
    if (!value) {
      form.setFieldValue('Port', 0);

      return;
    }
    form.setFieldValue('Port', Number(value));
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>{t('SettingSIEMSystem.title')}</div>

      {isLoading && (
        <div className={classes.skeletons}>
          <Skeleton height={20} radius="sm" width={100} />
          <Skeleton height={20} mt={4} radius="sm" width={100} />
          <Skeleton height={10} mt={20} radius="sm" width={100} />
          <Skeleton height={30} mt={4} radius="sm" width={350} />
          <Skeleton height={10} mt={20} radius="sm" width={100} />
          <Skeleton height={30} mt={4} radius="sm" width={350} />
          <Skeleton height={10} mt={20} radius="sm" width={100} />
          <Skeleton height={30} mt={4} radius="sm" width={350} />
          <Skeleton height={40} mt={10} radius="sm" width={100} />
        </div>
      )}
      {!isLoading && (
        <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
          <Radio
            className={classes.radio}
            size="xs"
            checked={!form.values.IsEnabled}
            onChange={() => form.setValues({ IsEnabled: false })}
            label={t('SettingSIEMSystem.turnOff')}
          />
          <Radio
            className={classes.radio}
            size="xs"
            checked={form.values.IsEnabled}
            onChange={() => form.setValues({ IsEnabled: true })}
            label={t('SettingSIEMSystem.turnOn')}
          />
          <Input.Wrapper className={classes.label} label={t('SettingSIEMSystem.host')}>
            <Input
              {...form.getInputProps('Host')}
              disabled={!form.values.IsEnabled}
              className={classes.input}
            />
          </Input.Wrapper>
          <Input.Wrapper className={classes.label} label={t('SettingSIEMSystem.port')}>
            <NumberInput
              {...form.getInputProps('Port')}
              onChange={handleChangePort}
              hideControls
              disabled={!form.values.IsEnabled}
              className={classes.input}
            />
          </Input.Wrapper>
          <Input.Wrapper className={classes.label} label={t('SettingSIEMSystem.format')}>
            <Select
              {...form.getInputProps('Format')}
              onChange={handleChangeSelectSIEM}
              disabled={!form.values.IsEnabled}
              className={classes.select}
              rightSection={<IconChevronDown size="1rem" color="#98A2B3" />}
              value={currentValue?.value}
              data={options}
              comboboxProps={{ transitionProps: { transition: 'pop', duration: 200 } }}
            />
          </Input.Wrapper>
          <Button
            size="sm"
            loading={isPartLoading}
            radius={8}
            disabled={isDisabledButton}
            mr="sm"
            type="submit"
          >
            {t('save')}
          </Button>
        </form>
      )}
    </div>
  );
};
